import { render, staticRenderFns } from "./AtalhosRapidos.vue?vue&type=template&id=0c39e48c&scoped=true"
import script from "./AtalhosRapidos.vue?vue&type=script&lang=js"
export * from "./AtalhosRapidos.vue?vue&type=script&lang=js"
import style0 from "./AtalhosRapidos.vue?vue&type=style&index=0&id=0c39e48c&prod&scoped=true&lang=css"
import style1 from "./AtalhosRapidos.vue?vue&type=style&index=1&id=0c39e48c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c39e48c",
  null
  
)

export default component.exports